const Session = (($) => {
    const NAME = 'session';
    const DATA_KEY = `bs.${NAME}`;
    const JQUERY_NO_CONFLICT = $[NAME];

    const Default = {
        debug: false,
        title: 'Your Session Is About To Expire!',
        message: '<p>Your session is about to expire due to inactivity.<br/>Expiring in: <strong></strong></p><br/><small>**Due to server latency, your session may expire a couple of seconds earlier than indicated.</small>',
        logoutUrl: '/account/logout',
        keepAliveUrl: '/home/keepAlive',
        countDownTarget: 'strong',
        warnAfter: 27,    // 27 mins
        redirtAfter: 30    // 30 mins 
    };

    class Session {
        constructor(options) {
            this.options = $.extend({}, Default, options);

            //convert minutes to milli-seconds
            this.options.redirtAfter = this.options.redirtAfter * 60 * 1000;
            this.options.warnAfter = this.options.warnAfter * 60 * 1000;

            this.interval = this.options.redirtAfter - this.options.warnAfter;
            this.$dialog = null;
            this.$placeholder = null;
            this.warningIntervalId = null;
            this.redirIntervalId = null;
            this.countDownIntervalId = null;
            this.reset();
        }

        warningTimer(action) {
            if (action === 'start') {
                this.warningIntervalId = setTimeout(() => {
                    this.warningTimer('stop');
                    this.showDialog();
                    if (this.options.debug) {
                        this.$dialog.modal('hide');
                    } else {
                        this.redirTimer('start');
                    }
                }, this.options.warnAfter);
            } else {
                this.warningIntervalId && clearTimeout(this.warningIntervalId);
            }
        }

        showDialog() {
            const messageId = new Date().getUTCSeconds() + "_message";

            this.$dialog = bootbox.confirm({
                buttons: {
                    cancel: {
                        label: 'Log out',
                        className: 'btn-danger'
                    },
                    confirm: {
                        label: 'Stay Connected',
                        className: 'btn-primary position-left'
                    }
                },
                callback: (...args) => {
                    if (args[0]) {
                        $.get({
                            url: this.options.keepAliveUrl,
                            success: () => {
                                this.reset();
                            }
                        });
                    }
                    else {
                        window.location.href = this.options.logoutUrl;
                    }
                },
                className: 'bootbox-header-danger',
                closeButton: false,
                onEscape: false,
                message: `<div id=${messageId}> ${this.options.message}</div>`,
                size: "small",
                title: this.options.title
            });

            this.$placeholder = this.options.countDownTarget ? $("#" + messageId).find(this.options.countDownTarget) : null;
            this.$placeholder && this.$placeholder.data('int', parseFloat(this.interval / 1000)).attr('class', '');
        }

        redirTimer(action) {
            if (action === 'start') {
                this.countDownTimer('start');
                this.redirIntervalId = setTimeout(() => {
                    this.redirTimer('stop');
                    window.location = this.options.logoutUrl;
                }, this.interval);
            } else {
                this.countDownTimer('stop');
                this.redirIntervalId && clearTimeout(this.redirIntervalId);
            }
        }

        countDownTimer(action) {
            if (this.$placeholder) {
                if (action === 'start') {
                    this.calc();
                    this.countDownIntervalId = setInterval(() => {
                        this.$placeholder.data('int', parseFloat(this.$placeholder.data('int')) - 1);
                        this.calc();
                    }, 1000);
                } else {
                    this.countDownIntervalId && clearInterval(this.countDownIntervalId);
                }
            }
        }

        calc() {
            var interval = parseFloat(this.$placeholder.data('int')),
                min = Math.floor(interval / 60),
                sec = Math.floor(interval % 60);

            if (min > 0) {
                var val = min + ' minute' + (min > 1 ? 's' : '');

                if (sec > 0) {
                    val += ' ' + sec + ' second' + (sec > 1 ? 's' : '');
                }
                this.$placeholder.text(val);
            } else if (sec > 0) {
                this.$placeholder.text(sec + ' second' + (sec > 1 ? 's' : ''));
                if (sec < 30) {
                    this.$placeholder.addClass('text-warning');
                }
                if (sec < 15) {
                    this.$placeholder.removeClass('text-warning').addClass('text-danger');
                }
            } else {
                this.$placeholder.text('');
            }

            this.options.debug && this.$placeholder && console.log(this.$placeholder.text());
        }

        reset() {
            if (this.$dialog) {
                this.$dialog.modal('hide');
            }
            this.redirTimer('stop');
            this.warningTimer('stop');
            this.warningTimer('start');
        }

        static _jQueryInterface(option) {
            const $body = $('body'); // hook session data to body
            let data = $body.data(DATA_KEY);
            const config = $.extend({}, Default, $body.data(), option);
            if (!data) {
                data = new Session(config);
                $body.data(DATA_KEY, data);
            }
            else {
                data.reset();
            }
        }
    }

    $(document).ajaxStop(() => Session._jQueryInterface.call());
    $.extend({
        [NAME]: Session._jQueryInterface
    });

    $[NAME].Constructor = Session;
    $[NAME].noConflict = function () {
        $[NAME] = JQUERY_NO_CONFLICT;
        return Session._jQueryInterface;
    }

    return Session;
})(jQuery);